<template>
  <v-container fluid>
    <BaseTable
      :items="items"
      :headers="headers"
      title="Überschreibung: Monate im Abo"
      componentName="NgwOverwriteMonthInAboNull"
      :editMutation="'updateOverwriteMonthInAboNull'"
      :deleteMutation="'deleteOverwriteMonthInAboNull'"
      @refresh="updateList"
      :loading="loading"
      isApprovedButton
    />
  </v-container>
</template>

<script>
import { API } from "aws-amplify";
import { listOverwriteMonthInAboNulls } from "@/graphql/queries";
import BaseTable from "@/components/BaseTable.vue";

export default {
  name: "Anfo",
  components: {
    BaseTable,
  },
  async created() {
    this.updateList();
  },
  methods: {
    updateList() {
      this.getList();
    },
    async getList() {
      this.loading = true;
      const response = await API.graphql({
        query: listOverwriteMonthInAboNulls,
        variables: {
          limit: 1000
        }
      });
      this.items = response.data.listOverwriteMonthInAboNulls.items;
      this.loading = false;
    },
  },
  data() {
    return {
      headers: [
        { text: "Artikel", value: "article.code" },
        { text: "Werbeweg", value: "marketingType.code" },
        {
          text: "Kondition",
          value: "condition.name",
        },
        { text: "Grenztyp", value: "minMax" },


        {
          text: "Monatesgrenze",
          value: "monthThreshold",
        },
        { text: "Grund", value: "reason" },
        { text: "Gültig von", value: "validFrom" },
        { text: "Gültig bis", value: "validTill" },
        { text: "Freig. Verlag", value: "approvedPublisherBy" },
        { text: "Freig. Controll.", value: "approvedControllingBy" }
      ],
      items: [],
      loading: true,
    };
  },
};
</script>
